<template>
  <v-col cols="12">
    <v-form ref="printDataShopForm">
      <base-card>
        <v-card-title>
          Impresión de datos del establecimiento en RIDE
        </v-card-title>
        <v-card-text>
          <v-row v-can="'Selector Compañias'">
            <v-col cols="12" sm="4">
              <v-select
                ref="cliente"
                v-model="data.IdCompania"
                :items="detailClients"
                item-text="text"
                item-value="id"
                label="Compañia"
                prepend-inner-icon="mdi-sitemap"
                :error="companySelectorError"
                :rules="[validateCompanyField]"
                :error-messages="helperSelectorText"
                @change="handleSelectChange"
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-text-field
                          class="search-field"
                          v-model="search"
                          placeholder="Buscar"
                          prepend-inner-icon="mdi-magnify"
                          hide-details
                        />
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2 btn-primary"
                @click="checkCompanyField"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="searchIfIsAdmin">
            <v-col
              cols="12"
              sm="4"
            >
              <v-switch
                v-model="data.configStatus"
                :label="`${data.configStatus ? '(Activo) Imprime datos del establecimiento en el RIDE(Representación gráfica del FE)' : '(Inactivo) Imprime datos de la compañia en el RIDE(Representación gráfica del FE)'}`"
                hide-details
                inset
              />
            </v-col>

               <v-col
              cols="12"
              sm="2"
            >
              <v-btn
                class="ma-2 btn-primary"
                @click="validateConfigData"
              >
                Guardar
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            v-if="loadingConfig"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                {{ loadingMessage }}
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                v-show="showAlert"
                :type="alertType"
                text
              >
                {{ alertMessage }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-form>
  </v-col>
</template>

<script>

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

export default {
  name: 'ConfigPrintDataShop',

  data() {
    const userData = getUserData()
    const roles = JSON.parse(localStorage.getItem('role') || '[]')
    const isGeneralAdmin = roles.includes('General-Admin') || roles.includes('General')

    return {
      data: {
        configStatus: false,
      },
      searchIfIsAdmin: false,
      search: '',
      errorMessages: '',
      formHasErrors: null,
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
      loadingConfig: false,
      loadingMessage: '',
      formRules: [
        (v) => !!v || 'Este campo es requerido (Solo acepta números)'
      ],
      companySelectorError: false,
      helperSelectorText: '',
      firstTime: true,
      isAdmin: !isGeneralAdmin,
      isGeneralAdmin: isGeneralAdmin,
      userIdCompania: userData.idcompania,
    }
  },

  computed: {
    statusResponseUpdatePrintDataShopConfig() {
      return this.$store.state.printDataShop.statusSetPrintDataShop
    },
    statusResponseGetPrintDataShopConfig() {
      return this.$store.state.printDataShop.statusGetPrintDataShop
    },
    detailClients() {
      if (this.isAdmin) {
        return (
          this.$store.state.printDataShop.listClients.Mensaje || []
        )
          .filter((compania) => compania.active === 1)
          .filter((compania) =>
            compania.name.toLowerCase().includes(
              this.search.toLowerCase()
            )
          )
          .map((compania) => ({
            ...compania,
            text: `[${compania.id}] ${compania.name}`,
          }));
      }

      return (this.$store.state.printDataShop.listClients.Mensaje || []).filter(
        (compania) => compania.id === this.userIdCompania
      );
    },
  },

  created () {
    if (!this.isAdmin) {
      this.loadingConfig = true
      this.loadingMessage = 'Consultando configuración...'
      this.getPrintDataShopConfig()
      this.searchIfIsAdmin = true
    }
    this.getListClients()
  },

  watch: {
    '$store.state.printDataShop.printDataShop': {
      handler(data) {
        if (data && data.ImprimeDatosEstablecimiento !== undefined) {
          this.data.configStatus = data.ImprimeDatosEstablecimiento === '1'
        }
      },
      deep: true
    },
    formHasErrors () {
      if (this.formHasErrors === false) {
        this.sendPrintDataShopConfig()
        this.formHasErrors = null
      }
    },
    statusResponseUpdatePrintDataShopConfig () {
      if(this.statusResponseUpdatePrintDataShopConfig === false) {
        this.loadingConfig = false
        this.alertType = 'success'
        this.alertMessage = this.$store.state.printDataShop.printDataShopConfigMessage
        this.generateAlert()
        this.formHasErrors = true
        this.$store.dispatch('printDataShop/setUpdateStatusResponse', null)
      } else if(this.statusResponseUpdatePrintDataShopConfig === true) {
        this.loadingConfig = false
        this.alertType = 'error'
        this.alertMessage = this.$store.state.printDataShop.printDataShopConfigMessage
        this.generateAlert()
        this.formHasErrors = true
        this.$store.dispatch('printDataShop/setUpdateStatusResponse', null)
      }
    },
    statusResponseGetPrintDataShopConfig () {
      if(this.statusResponseGetPrintDataShopConfig === false) {
        this.loadingConfig = false
        this.searchIfIsAdmin = true
        this.alertType = 'success'
        this.alertMessage = this.$store.state.printDataShop.printDataShopConfigMessage
        this.generateAlert()
        this.$store.dispatch('printDataShop/statusGetPrintDataShop', null)
      } else if(this.statusResponseGetPrintDataShopConfig === true) {
        this.loadingConfig = false
        this.searchIfIsAdmin = true
        this.alertType = 'error'
        this.alertMessage = this.$store.state.printDataShop.printDataShopConfigMessage
        this.generateAlert()
        this.$store.dispatch('printDataShop/statusGetPrintDataShop', null)
      }
    }
  },

  methods: {
    async getListClients () {
      await this.$store.dispatch('printDataShop/getListClients')
    },
    async getPrintDataShopConfig () {
      await this.$store.dispatch('printDataShop/getPrintDataShopConfig', {
        ...this.data
      })
    },
    generateAlert () {
      this.showAlert = true
      setTimeout(() => {
        this.showAlert = false
      }, 3000)
    },
    validateConfigData () {
      this.formHasErrors = !this.$refs.printDataShopForm.validate();
      if (!this.formHasErrors) {
        this.loadingConfig = true
        this.loadingMessage = 'Guardando configuración...'
      }
    },
    sendPrintDataShopConfig () {
      this.$store.dispatch('printDataShop/updatePrintDataShopConfig', {
        ...this.data
      })
    },
    validateCompanyField(value) {
      if ((!value || value <= 0) && this.firstTime === false) {
        this.companySelectorError = true
        this.helperSelectorText = 'El campo no puede estar vacío.'
        return false
      } else {
        this.companySelectorError = false
        this.helperSelectorText = ''
        return true
      }
    },
    checkCompanyField() {
      this.firstTime = false
      if (this.validateCompanyField(this.data.IdCompania)) {
        this.loadingConfig = true
        this.loadingMessage = 'Consultando configuración...'
        this.getPrintDataShopConfig()
      }
    },
    handleSelectChange (newValue) {
      this.searchIfIsAdmin = false
    }
  }
}

</script>

<style scoped>
.btn-primary {
  background-color: rgb(204, 33, 40) !important;
  color: white !important;
}
</style>
